import { EventSearchForm } from '@mark43/cad-api';
import { createContext, ReactNode, useContext } from 'react';
import { TabsContextType, useSearchTabs } from '../search-windows/use-search-tabs';

const EventSearchTabsContext = createContext<TabsContextType<EventSearchForm> | undefined>(
    undefined
);

export function useEventSearchTabsContext() {
    const context = useContext(EventSearchTabsContext);
    if (context === undefined) {
        throw new Error('useEventSearchTabsContext must be used within an EventSearchTabsProvider');
    }
    return context;
}

export const EventSearchTabsProvider = ({
    initialTab,
    children,
}: {
    initialTab: string;
    children: ReactNode;
}) => {
    const tabsValue = useSearchTabs<EventSearchForm>(initialTab);
    return (
        <EventSearchTabsContext.Provider value={tabsValue}>
            {children}
        </EventSearchTabsContext.Provider>
    );
};
